import { Box, Typography } from '@mui/material';

const EmptyResults = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 10, px: 2 }}>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      No products found
    </Typography>
    <Typography variant="body2" color="text.secondary" textAlign="center">
      Try adjusting your search or filters.
    </Typography>
  </Box>
);

export default EmptyResults;
